import { render, staticRenderFns } from "./ContentSlideRightClickMenu.vue?vue&type=template&id=808bd4dc&"
import script from "./ContentSlideRightClickMenu.vue?vue&type=script&lang=js&"
export * from "./ContentSlideRightClickMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlideRightClickMenu.vue?vue&type=style&index=0&id=808bd4dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports